import styled, { AnyStyledComponent } from 'styled-components'

import MapPin from '../../assets/icons/userbar-icons/map-pin.svg'
import Calendar from '../../assets/icons/userbar-icons/calendar.svg'
import Users2 from '../../assets/icons/userbar-icons/users2.svg'
import Mail from '../../assets/icons/userbar-icons/mail.svg'
import Call from '../../assets/icons/userbar-icons/call.svg'
import Thunder from '../../assets/icons/userbar-icons/thunder.svg'
import Whatsapp from '../../assets/icons/userbar-icons/whatsapp.svg'
import Facebook from '../../assets/icons/userbar-icons/facebook.svg'
import Link from '../../assets/icons/userbar-icons/link.svg'
import Messanger from '../../assets/icons/userbar-icons/messanger.svg'
import Cancel from '../../assets/icons/userbar-icons/cancel.svg'
import Back from '../../assets/icons/userbar-icons/back.svg'
import ChevronDown from '../../assets/icons/chevron-down.svg'
import ChevronRight from '../../assets/icons/chevron-right.svg'
import ChevronLeft from '../../assets/icons/chevron-left.svg'
import CircledCrossMini from '../../assets/icons/userbar-icons/circled-cross-mini.svg'
import TickIcon from '../../assets/icons/tick.svg'
import ExternalIcon from '../../assets/icons/external-icon.svg'
import Duration from '../../assets/icons/duration.svg'
import Clock from '../../assets/icons/clock.svg'
import Home from '../../assets/icons/home.svg'
import Buy from '../../assets/icons/buy.svg'
import MiniLogo from '../../assets/logo/tfw-logo-symbol.svg'
import HeartImageIcon from '../../assets/icons/heart.svg'
import HeartOImageIcon from '../../assets/icons/heart-o.svg'
import BuildingIconImage from '../../assets/icons/home-border.svg'
import EditIconImage from '../../assets/icons/pencil.svg'
import FastResponder from '../../assets/icons/fast-responder.svg'

export const LocationPinIcon = styled(MapPin as AnyStyledComponent)`
    /* Provide min width and height so that the element isn't small-sized when present inside a flex container. */
    min-width: ${({ theme }) => theme.layout.xSmall};
    min-height: ${({ theme }) => theme.layout.xSmall};
`

export const BuildingIcon = styled(BuildingIconImage as AnyStyledComponent)`
    min-width: ${({ theme }) => theme.layout.xxSmall};
    min-height: ${({ theme }) => theme.layout.xxSmall};
`

export const EditIcon = styled(EditIconImage as AnyStyledComponent)`
    min-width: ${({ theme }) => theme.layout.xxSmall};
    min-height: ${({ theme }) => theme.layout.xxSmall};
`

export const CalendarIcon = styled(LocationPinIcon as AnyStyledComponent).attrs({ as: Calendar })``
export const GuestsIcon = styled(LocationPinIcon as AnyStyledComponent).attrs({ as: Users2 })``
export const MailIcon = styled(LocationPinIcon as AnyStyledComponent).attrs({ as: Mail })``
export const WhatsappIcon = styled(LocationPinIcon as AnyStyledComponent).attrs({ as: Whatsapp })``
export const FacebookIcon = styled(LocationPinIcon as AnyStyledComponent).attrs({ as: Facebook })``
export const MessangerIcon = styled(LocationPinIcon as AnyStyledComponent).attrs({ as: Messanger })``
export const LinkIcon = styled(LocationPinIcon as AnyStyledComponent).attrs({ as: Link })``
export const CallIcon = styled(LocationPinIcon as AnyStyledComponent).attrs({ as: Call })``
export const ThunderIcon = styled(LocationPinIcon as AnyStyledComponent).attrs({ as: Thunder })``
export const FastResponderIcon = styled(FastResponder as AnyStyledComponent).attrs({ title: 'Fast responder' })``

export const CancelIcon = styled(Cancel as AnyStyledComponent).attrs({ width: '12px', height: '12px' })`
    min-width: 0.75rem;
    min-height: 0.75rem;
`

export const BackIcon = styled(Back).attrs({ width: '14px', height: '14px' })`
    min-width: 0.875rem;
    min-height: 0.875rem;
`

export const ChevronUpIcon = styled(ChevronDown).attrs({ width: '12px', height: '12px' })`
    min-width: 0.75rem;
    min-height: 0.75rem;
    transform: rotate(180deg);
`

export const ChevronDownIcon = styled(ChevronDown as AnyStyledComponent).attrs({ width: '12px', height: '12px' })`
    min-width: 0.75rem;
    min-height: 0.75rem;
`

export const ChevronRightIcon = styled(ChevronDownIcon).attrs({ as: ChevronRight })``
export const ChevronLeftIcon = styled(ChevronDownIcon).attrs({ as: ChevronLeft })``

export const CircledCrossMiniIcon = styled(CircledCrossMini)`
    min-width: 1rem;
    min-height: 1rem;
`
export const EventTickIcon = styled(TickIcon as AnyStyledComponent)`
    min-width: 0.875rem;
    max-width: 0.875rem;
    height: 0.875rem;
`

export const ExternalPageIcon = styled(ExternalIcon as AnyStyledComponent)`
    /* Provide min width and height so that the element isn't small-sized when present inside a flex container. */
    min-width: ${({ theme }) => theme.layout.xxSmall};
    min-height: ${({ theme }) => theme.layout.xxSmall};
`

export const DurationIcon = styled(LocationPinIcon as AnyStyledComponent).attrs({ as: Duration })``
export const ClockIcon = styled(LocationPinIcon as AnyStyledComponent).attrs({ as: Clock })``
export const HomeIcon = styled(LocationPinIcon as AnyStyledComponent).attrs({ as: Home })``
export const BuyIcon = styled(LocationPinIcon as AnyStyledComponent).attrs({ as: Buy })``
export const MiniLogoIcon = styled(CancelIcon as AnyStyledComponent).attrs({ as: MiniLogo })`
    min-width: 1.25rem;
    min-height: 100%;
`

export const HeartIcon = styled(HeartImageIcon as AnyStyledComponent)`
    width: 1rem;
    min-height: 1rem;
`

export const HeartOIcon = styled(HeartIcon as AnyStyledComponent).attrs({ as: HeartOImageIcon })``
